module.exports = __webpack_public_path__ + "static/media/harawork.logo.f6289d50.png";